/** Safari-friendly MIME for lead origin recordings. */

export function playbackMime(contentType: string): string {
    const mime = contentType.split(';')[0].trim().toLowerCase();
    if (mime === 'video/webm') return 'audio/webm';
    if (mime === 'video/mp4' || mime === 'audio/x-m4a' || mime === 'audio/m4a' || mime === 'audio/aac') {
        return 'audio/mp4';
    }
    return mime;
}

export function canPlayLeadAudio(
    contentType: string,
    probe?: Pick<HTMLMediaElement, 'canPlayType'>
): boolean {
    const mime = playbackMime(contentType);
    if (!mime) return false;
    const el = probe ?? (typeof Audio !== 'undefined' ? new Audio() : null);
    if (!el) return true;
    return el.canPlayType(mime) !== '';
}

/** Safari blob URLs often report duration Infinity until a dummy seek past EOF. */
export function attachSafariDurationFix(el: HTMLAudioElement): () => void {
    const seekIfNeeded = () => {
        if (Number.isFinite(el.duration) && el.duration > 0) return;
        el.currentTime = 1e101;
        const onTimeUpdate = () => {
            el.removeEventListener('timeupdate', onTimeUpdate);
            el.currentTime = 0;
        };
        el.addEventListener('timeupdate', onTimeUpdate);
    };
    if (el.readyState >= HTMLMediaElement.HAVE_METADATA) seekIfNeeded();
    el.addEventListener('loadedmetadata', seekIfNeeded);
    return () => el.removeEventListener('loadedmetadata', seekIfNeeded);
}
